import { FunctionComponent } from "react";
import { PresentationalUsersList } from "./views/users";
import { UsersComponentProps, UsersSearchComponent } from "./search-wrapper";
import { Widget } from "../../../components/widget";
import { H1 } from "../../../components/typography";
import styled from "styled-components";
import { Flex } from "../../../components/layout";

const Header = styled(Flex)`
  justify-content: space-between;
`;

export const UsersComponent: FunctionComponent<UsersComponentProps> = (
  props
) => (
  <Widget>
    <Header>
      <H1 className="h1">Users</H1>
    </Header>
    <UsersSearchComponent {...props}>
      <PresentationalUsersList />
    </UsersSearchComponent>
  </Widget>
);
